export const courseDetailsMessages = {
    moduleDone: {
        key: "courseDetails.labelsAndTitles.MODULES_DONE",
    },
    onGoing: {
        key: "courseDetails.labelsAndTitles.YOUR_CURRENT_ACTIVITY",
    },
    enroll: {
        key: "general.enroll",
    },
    shortcutsToHelp: {
        key: "courseDetails.labelsAndTitles.SHORTCUTS_TO_HELP",
    },
    clearConversation: {
        key: "courseDetails.labelsAndTitles.CLEAR_CONVERSATION",
    },
    typeHere: {
        key: "courseDetails.labelsAndTitles.TYPE_HERE",
    },
    aboutCourse: {
        key: "courseDetails.labelsAndTitles.ABOUT_COURSE",
    },
    downloadCertificate: {
        key: "courseDetails.labelsAndTitles.DOWNLOAD_CERTIFICATE"
    },
    overview: {
        key: "courseDetails.labelsAndTitles.OVERVIEW"
    },
    scorecard: {
        key: "courseDetails.labelsAndTitles.SCORECARD"
    },
    courseContent: {
        key: "courseDetails.labelsAndTitles.COURSE_CONTENT"
    },
    connectDiscourse: {
        key: "courseDetails.labelsAndTitles.CONNECT_DISCOURSE"
    },
    currentScore: {
        key: "courseDetails.labelsAndTitles.CURRENT_SCORE"
    },
    completed: {
        key: "global.labelsAndTitles.COMPLETED"
    },
    back: {
        key: "global.actions.BACK"
    },
    previous: {
        key: "courseDetails.labelsAndTitles.PREVIOUS"
    },
    next: {
        key: "courseDetails.labelsAndTitles.NEXT"
    },
    fullscreen: {
        key: "courseDetails.labelsAndTitles.FULLSCREEN"
    },
    exitFullscreen: {
        key: "courseDetails.labelsAndTitles.EXIT_FULLSCREEN"
    },
    congratulations: {
        key: "courseDetails.labelsAndTitles.CONGRATULATIONS"
    },
    moreThan70: {
        key: "courseDetails.labelsAndTitles.YOU_SCORED_MORE_70"
    },
    shareThisCertificate: {
        key: "courseDetails.labelsAndTitles.SHARE_THIS_CERTIFICATE"
    },
    copyLink: {
        key: "courseDetails.labelsAndTitles.COPY_LINK"
    },
    earnCertificate: {
        key: "courseDetails.labelsAndTitles.EARN_CERTIFICATE"
    },
    completeCourseCertificationDesc1: {
        key: "courseDetails.labelsAndTitles.COMPLETE_THE_COURSE_CERTIFICATE_DESC1"
    },
    completeCourseCertificationDesc2: {
        key: "courseDetails.labelsAndTitles.COMPLETE_THE_COURSE_CERTIFICATE_DESC2"
    },
    certificateNotAvailable: {
        key: "courseDetails.labelsAndTitles.CERTIFICATE_NOT_AVAILABLE"
    },
    certificateLinkCopied: {
        key: "courseDetails.labelsAndTitles.CERTIFICATE_LINK_COPIED"
    },
    infoDescription1: {
        key: "courseDetails.labelsAndTitles.INFO_DESCRIPTION1"
    },
    infoDescription2: {
        key: "courseDetails.labelsAndTitles.INFO_DESCRIPTION2"
    },
    finalScore: {
        key: "courseDetails.labelsAndTitles.FINAL_SCORE"
    },
    courseIncludes: {
        key: "courseDetails.labelsAndTitles.COURSE_INCLUDES"
    },
    skillsLearn: {
        key: "courseDetails.labelsAndTitles.SKILLS_LEARN"
    },
    sector: {
        key: "courseDetails.labelsAndTitles.SECTOR"
    },
    language: {
        key: "courseDetails.labelsAndTitles.LANGUAGE"
    },
    lessons: {
        key: "courseDetails.labelsAndTitles.LESSONS"
    },
    assessments: {
        key: "courseDetails.labelsAndTitles.ASSESSMENTS"
    },
    assessment: {
        key: "courseDetails.labelsAndTitles.ASSESSMENT"
    },
    hours: {
        key: "courseDetails.labelsAndTitles.HOURS"
    },
    courseBySectors: {
        key: "courseDetails.labelsAndTitles.COURSE_BY_SECTORS"
    },
    popularCourses: {
        key: "courseDetails.labelsAndTitles.POPULAR_COURSES"
    },
    courseCatalog: {
        key: "courseDetails.labelsAndTitles.COURSE_CATALOG"
    },
    courses: {
        key: "layout.labelsAndTitles.COURSES_MENU"
    },
    course: {
        key: "courseDetails.labelsAndTitles.COURSE"
    },
    contentError: {
        key: "courseDetails.labelsAndTitles.CONTENT_ERROR"
    },
    AI_INPUT_DISCAILMER: {
        key: "courseDetails.labelsAndTitles.AI_INPUT_DISCAILMER"
    },
    AI_INPUT_DISCAILMER1: {
        key: "courseDetails.labelsAndTitles.AI_INPUT_DISCAILMER1"
    },
    answere: {
        key: "courseDetails.labelsAndTitles.ANSWERE"
    },
    startSpeak: {
        key: "courseDetails.labelsAndTitles.START_SPEAK"
    },
    aiInputPlaceholder: {
        key: "courseDetails.labelsAndTitles.AI_INPUT_PLACEHOLDER"
    },
    aiInfoText: {
        key: "courseDetails.labelsAndTitles.AI_INFO_TEXT"
    },
    toolkit: {
        key: "courseDetails.labelsAndTitles.TOOLKIT"
    },
    here: {
        key: "courseDetails.labelsAndTitles.HERE"
    },
    start: {
        key: "courseDetails.labelsAndTitles.START"
    },
    myTutor: {
        key: "courseDetails.labelsAndTitles.myTutor"
    },
    myMentor: {
        key: "courseDetails.labelsAndTitles.myMentor"
    },
    scoreMoreToEarnMicroCertificate: {
        key: "courseDetails.labelsAndTitles.SCOREMORE_TO_EARN_MICRO_CERTIFICATE"
    },
    earnYourMicroCertificate: {
        key: "courseDetails.labelsAndTitles.EARN_YOUR_MICRO_CERTIFICATE"
    },
    completeCourseWith: {
        key: "courseDetails.labelsAndTitles.COMPLETE_COURSE_WITH"
    },
    withThresholdScore: {
        key: "courseDetails.labelsAndTitles.WITH_THRESHOLD_SCORE"
    },
    certificateAvailable: {
        key: "courseDetails.labelsAndTitles.CERTIFICATE_AVAILABLE"
    },
    scoredThresholdScore: {
        key: "courseDetails.labelsAndTitles.SCORED_THRESHOLD_SCORE"
    },
    download: {
        key: "cohort.labelsAndTitles.DOWNLOAD"
    },
    share: {
        key: "courseDetails.labelsAndTitles.SHARE"
    },
    performance: {
        key: "layout.labelsAndTitles.PERFORMANCE"
    },
    notApplicable: {
        key: "courseDetails.labelsAndTitles.NOT_APPLICABLE"
    },
    seeYourPerformance: {
        key: "courseDetails.labelsAndTitles.SEE_YOUR_PERFORMANCE"
    },
    completeAllAssessment: {
        key: "courseDetails.labelsAndTitles.COMPLETE_ALL_ASSESSMENT"
    },
    scoreCard: {
        key: "courseDetails.labelsAndTitles.SCORE_CARD"
    },
    availableSkillScoreCard: {
        key: "courseDetails.labelsAndTitles.AVAILABLE_SKILL_SCORECARD"
    },
    weightedScore: {
        key: "courseDetails.labelsAndTitles.WEIGHTED_SCORE"
    },
    selectLearnerSector: {
        key: "courseDetails.labelsAndTitles.SELECT_LEARNER_SECTOR"
    },
    selectLearnerIdea: {
        key: "courseDetails.labelsAndTitles.SELECT_LEARNER_IDEA"
    },
    currentActivities: {
        key: "courseDetails.labelsAndTitles.currentActivities"
    },
    nextLesson: {
        key: "courseDetails.labelsAndTitles.NEXT_LESSON"
    },
    resume: {
        key: "courseDetails.actions.RESUME"
    },
    gotToCourse: {
        key: "courseDetails.actions.GO_TO_COURSE"
    },
    overallProgress: {
        key: "courseDetails.labelsAndTitles.OVERALL_PROGRESS"
    },
};




